import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

import MyNavbar from '../CommonComponents/Navbar'
import MyFooter from '../CommonComponents/Footer'


export default class Developer extends Component {
        render() {
                return (
                        <div id="main-developer-page">
                                <MyNavbar backgroundColor="white"/>
                                <MyFooter />
                        </div>
                )
        }
}
